import React, { useState } from 'react'
import { 
  Box, 
  Typography,
  Button
} from '@mui/material'
import { useSelector, useDispatch } from 'react-redux'
import { useLocation, useNavigate } from 'react-router-dom'
import {
  updateProductQty,
  removeProduct,
  resetDP
} from './reducer/DpActions'
import {
  selectCurrentCart,
  selectCurrentCartTotals,
  selectOrderBookingId,
  selectSelectedShipToPartyId,
  selectShipToPartyCarts
} from './reducer/DpSelectors'
import ProductCard from '../../Inventory/components/ProductCard'
import { CustomButton } from '../../../v2/MUI_custom_component'
import { DP_ROUTE_SOURCE } from './Enums'
import { ModifyOrderAction } from './API/Action'
import { toast } from 'react-toastify'
import { OperationType } from '../../../utils/settings'
import DisclaimerSvg from '../../Illustrration/components/DisclaimerSvg'
import HumbeeModal from '../../../v2/MUI_custom_component/Modal/HumbeeModal'

const DPCart = () => {
    const navigate = useNavigate()
    const dispatch = useDispatch()
    const location = useLocation();
    const selectedShipToPartyId = useSelector(selectSelectedShipToPartyId)
    const shipToPartyCarts = useSelector(selectShipToPartyCarts);
    const cartItems = useSelector(selectCurrentCart)
    const cartTotals = useSelector(selectCurrentCartTotals)
    const orderBookingId = useSelector(selectOrderBookingId)
    const source = location.state?.from;
    const [showUpdateOrderModal, setshowUpdateOrderModal] = useState(false)
    const [loading, setLoading] = useState(false)

    
    const handleQuantityIncrease = (productId) => {
        const currentProduct = cartItems.find(p => p.product_id === productId)
        if (currentProduct) {
            const newQuantity = currentProduct.quantity.quantity_in_metric_ton + 1
            dispatch(updateProductQty(productId, newQuantity, selectedShipToPartyId))
        }
    }
    const { selectedEntity: selectedCompanyEntity } = useSelector(
        (state) => state.entityReducer
    );
    const handleQuantityDecrease = (productId) => {
        const currentProduct = cartItems.find(p => p.product_id === productId)
        if (currentProduct) {
            const newQuantity = currentProduct.quantity.quantity_in_metric_ton - 1
            if (newQuantity <= 0) {
                dispatch(removeProduct(productId, selectedShipToPartyId))
            } else {
                dispatch(updateProductQty(productId, newQuantity, selectedShipToPartyId))
            }
        }
    }
    const addProducts = async () => {
        const payload = {
            order_id: orderBookingId,
            order_products_delivery: Object.values(shipToPartyCarts)
            .map((stp) => {
                const d = stp.shipToPartyDetails;
                const newProducts = stp.cart.filter(
                    (item) => item.isExistingItem !== true
                );
                if (newProducts.length === 0) return null;

                return {
                ship_to_party_info: {
                    so_id: d?.humbee_so_id,
                    operation_type: null,
                    deliver_to: d?.company_id,
                    deliver_to_esi_id: d?.selected_esi_id,
                    requested_district_id: d?.delivery_district_id,
                    pricing_geography_id: d?.pricing_geography_id,
                },

                products_info: newProducts.map((item) => ({
                    order_product_delivery_id: null,
                    operation_type: OperationType['ADD'],
                    product_id: item.product_id,

                    quantity: {
                        quantity_in_bags: item.quantity.quantity_in_bags,
                        quantity_in_metric_ton: item.quantity.quantity_in_metric_ton,
                        multiplier: item.quantity.multiplier,
                        unit: item.quantity.unit,
                        base_unit: item.quantity.base_unit
                    },

                    form_type: item.form_type,
                    bundle: item.bundle || 0,
                    length: item.length || '',
                    remark: item.remark || ''
                }))
                };
            })
            .filter(Boolean)
        };

        setLoading(true)
        const { error, message } = await ModifyOrderAction(payload, selectedCompanyEntity);
        setLoading(false)
        
        if (!error) {
            toast.success(message)
            dispatch(resetDP())
            navigate(`/dispatch-plan-detail/${order_booking_id}`);
        }else{
            toast.error(message)
        }
    };
    const handleRemoveItem = (productId) => {
        dispatch(removeProduct(productId, selectedShipToPartyId))
    }
    const { order_booking_id } = useSelector((state) => {
        return {
            order_booking_id: state.dpReducer?.order_booking_id,
        };
    });

    const handleContinue = () => {
        if (cartItems.length === 0) {
            navigate('/create-dp');
            return;
        }
        if (source === DP_ROUTE_SOURCE.ORDER_SUMMARY) {
            navigate('/dp-order-summary');
            return;
        }
        if (source === DP_ROUTE_SOURCE.DP_DETAILS) {
            setshowUpdateOrderModal(true)
            // navigate(`/dispatch-plan-detail/${order_booking_id}`);
            return;
        }
        navigate('/dp-ship-to-party-selection', {
            state: {
                orderBookingId,
                selectedShipToPartyId,
            },
        });
    };

    const EmptyCartComponent = () => {
        return (
            <Box
                sx={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                py: 5,
                textAlign: 'center',
                }}
            >
                <img
                    src='https://d2djimvzddgguw.cloudfront.net/humbee-inventory/cart.png'
                    alt='Cart Empty'
                    style={{ width: '100%', maxWidth: 180, marginBottom: 20 }}
                />
                <Typography variant="h2" sx={{ mb: 2}}>
                    Cart Empty!
                </Typography>
                <Typography variant="body1" sx={{ mb: 4 }}>
                    Add products to cart to proceed.
                </Typography>
                <CustomButton
                    variant="filled"
                    color="primary"
                    label="Add Products"
                    onClick={() => {
                        navigate('/create-dp')
                    }}
                    sx={{ width: { xs: '80%', sm: 'auto' } }}
                />
            </Box>
        );
    };
    

    return (
        <>
            <Box sx={{ display: 'flex', justifyContent:'end', 
                p: { xs: 2, md: 0 },
                mr: { xs: 0, md: 4 }, 
                position: {xs: 'sticky', md: 'relative'}, 
                top: 0, 
                zIndex: 1000, 
                boxShadow: {xs: '0px 2px 8px 0px #0000001A', md: 'none'},
                background: {xs: '#FAFAFA', md: 'transparent'}
            }}>
                <CustomButton
                    variant="filled"
                    color="primary"
                    disabled={cartItems.length === 0}
                    label="Continue"
                    onClick={handleContinue}
                    sx={{ width : { xs: '100%', sm: 'auto' } }}
                />
            </Box>
            <Box sx={{ p: { xs: 2, sm: 4 } }}>
            
            {cartItems.length > 0 && (
                <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
                    <Box>
                        <Typography variant="h2">
                            Cart
                        </Typography>
                    </Box>
                    <Box sx={{ display: 'flex', justifyContent: 'space-between'}}>
                        <Typography variant="labelD">
                            Total Quantity: 
                        </Typography>
                        <Typography variant="labelD">
                            {cartTotals.total_quantity_in_metric_ton} {cartItems[0]?.quantity?.unit || 'Tons'}
                        </Typography>
                    </Box>
                    <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 2 }}>
                        <Typography variant="labelD">
                            UOM: 
                        </Typography>
                        <Typography variant="labelD">
                            {cartItems[0]?.quantity?.unit || 'Tons'}
                        </Typography>
                    </Box>
                </Box>
            )}
            <Box>
                {cartItems.length === 0 ? (
                <EmptyCartComponent />
                ) : (
                    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
                    {cartItems.map((item) => (
                        <ProductCard
                            key={item.product_id}
                            productName={item.product_name}
                            imageUrl={item.product_image || '/placeholder-image.png'}
                            price={item.current_price_per_unit}
                            quantity={item.quantity.quantity_in_metric_ton}
                            showQuantityControls={true}
                            showDeleteButton={true}
                            onIncreasePress={() => {
                                handleQuantityIncrease(item.product_id)
                            }}
                            onReducePress={() => {
                                handleQuantityDecrease(item.product_id)
                            }}
                            onTextChange={(event) => {
                                const input = event.target ? event.target.value : event
                                const newQty = parseFloat(input) || 0
                                if (newQty === 0) {
                                    handleRemoveItem(item.product_id)
                                } else {
                                    dispatch(updateProductQty(item.product_id, newQty, selectedShipToPartyId))
                                }
                            }}
                            onDelete={() => {
                                handleRemoveItem(item.product_id)
                            }}
                            row={{ 
                                product_info: { 
                                    product_id: item.product_id,
                                    product_name: item.product_name 
                                } 
                            }}
                        />
                    ))}
                    </Box>
                )}
            </Box>
            </Box>
            <HumbeeModal
                open={showUpdateOrderModal}
                onClose={() => setshowUpdateOrderModal(false)}
                onConfirm={addProducts}
                loading={loading}
                title='New items are added to your DP'
                subtitle='Your order will be updated.'
                confirmLabel = "Update Order"
                cancelLabel = "No"
                illustration={<DisclaimerSvg />}
                width={{ xs: 400 , md:  400 }}
            />
        </>
    )
    }

export default DPCart